import { CampaignsApi } from '../clients';

/**
 * Apply a promo code to an office as an admin.
 *
 * Resolves with nothing: the tab refetches the office's history rather than
 * splicing in the 201 body, which is a different shape from a history entry.
 *
 * @param {string} officeId - The office's 24-character id
 * @param {string} code - The code as the admin typed it; the service trims it
 * @returns {Promise<void>}
 */
export const applyOfficePromoCode = async (officeId, code) => {
  await CampaignsApi.applyOfficePromoCode(officeId, code);
};
